/**
 * @file index.tsx
 *
 * @fileoverview Renders a message for the applicant that the application is restricted and he/she can not apply.
 */
import React from 'react';
import { MessageAlert } from '~/vcl/atoms/02-messages/01-alert';
import InfoIcon from '~/vcl/icons/Info';
import FlexItems from '~/vcl/atoms/06-layout/03-flex';
import { Text } from '~/vcl/atoms/13-text/03-text';

interface ApplicationRestrictionMessageProps {
  message: string;
}
export default function ApplicationRestrictionMessage({
  message,
}: ApplicationRestrictionMessageProps) {
  return (
    <MessageAlert alertStyle="danger" type="assertive">
      <FlexItems gap={5} flexWrap="nowrap">
        <InfoIcon width={20} height={20} />
        <Text margin={0}>{message}</Text>
      </FlexItems>
    </MessageAlert>
  );
}
